export const BASE_API = 'https://minicro.api.zhongzhicloud.cn';
// export const BASE_API = document.location.protocol + '//www.qnj.com';
export const TEST_BASE_API = 'https://minicro.api.zhongzhicloud.cn';
// export const TEST_BASE_API = 'http://127.0.0.1:8000';
